import { render, staticRenderFns } from "./answering_shopping.vue?vue&type=template&id=be2f6016&scoped=true"
import script from "./answering_shopping.vue?vue&type=script&lang=js"
export * from "./answering_shopping.vue?vue&type=script&lang=js"
import style0 from "./answering_shopping.vue?vue&type=style&index=0&id=be2f6016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2f6016",
  null
  
)

export default component.exports